import React from 'react';

import './BlogPostCommentFormField.css';

const BlogPostCommentFormField = React.forwardRef(
  (
    {
      type,
      name,
      pattern,
      placeholder,
      value,
      label,
      onChange,
      autoComplete = 'off',
      required,
      className = '',
    },
    ref
  ) => {
    const classNames =
      `blog-post-comment-form-field-${type}-input ${className}`.trim();

    const commonProps = {
      name,
      placeholder,
      value,
      pattern,
      onChange,
      required,
      autoComplete,
      ref,
      className: classNames,
    };

    const InputComponent = type === 'textarea' ? 'textarea' : 'input';

    const extraProps = type !== 'textarea' ? { type } : {};

    return (
      <div className='blog-post-comment-input-container'>
        <label>
          {`${label}`} {required && <span>*</span>}
        </label>
        <InputComponent {...commonProps} {...extraProps} />
      </div>
    );
  }
);

export default BlogPostCommentFormField;
